import RenderForm from './render-form'
import NestedForm from './form-nested'
import FormWrapper from './form-wrapper'

export default {
  name: 'VsForm',
  functional: true,
  props: {
    items: {
      type: Array,
      default: null
    },
    columns: {
      type: [String, Number, Object],
      default: 2
    },
    gap: {
      type: [String, Object],
      default: 'sm'
    },
    wrapSlot: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'top'
    },
    nested: {
      type: Boolean,
      default: false
    }
  },
  render(h, { props, data, children }) {
    if (props.items && props.items.length) {
      return h(RenderForm, { ...data, props: props }, children)
    } else {
      return h(props.nested ? NestedForm : FormWrapper, data, children)
    }
  }
}
